import PaymentMethodList from "@/controllers/payment_method/payment-method-list.js";

export default {
  extends: PaymentMethodList,
}
